import { ShopperAgentEscalationConfigSchema } from "@redotech/redo-shopper-agent-settings-common/escalation-config";
import * as z from "zod";

/** Escalation row of the draft version, else the published one. */
export const getShopperAgentEscalationSettings = {
  name: "getShopperAgentEscalationSettings" as const,
  input: z.object({}),
  output: z.object({
    escalation: ShopperAgentEscalationConfigSchema.nullable(),
  }),
};
